import { render, staticRenderFns } from "./VxSkeleton.vue?vue&type=template&id=9ff96e1e&"
import script from "./VxSkeleton.vue?vue&type=script&lang=js&"
export * from "./VxSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports